window.UNIT_DIMENSION_MAP = {
  "fixed": {
    "gliding_one_panel": {
      "2668": {
        "full_lite": {
          "all": {
            "unit_dimension": "2'-7 1/2\" x 6'-7 1/2\"",
            "rough_opening": "2'-8 1/4\" x 6'-8\"",
            "glass_dimension": "21 5/16\" x 67\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "2'-7 1/2\" x 6'-7 1/2\"",
            "rough_opening": "2'-8 1/4\" x 6'-8\"",
            "glass_dimension": "20\" x 48\""
          }
        }
      },
      "2680": {
        "full_lite": {
          "all": {
            "unit_dimension": "2'-7 1/2\" x 7'-11 1/2\"",
            "rough_opening": "2'-8 1/4\" x 8'-0\"",
            "glass_dimension": "20\" x 80\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "2'-7 1/2\" x 7'-11 1/2\"",
            "rough_opening": "2'-8 1/4\" x 8'-0\"",
            "glass_dimension": "20\" x 64\""
          }
        }
      },
      "3068": {
        "full_lite": {
          "all": {
            "unit_dimension": "3'-1 1/2\" x 6'-7 1/2\"",
            "rough_opening": "3'-2 1/4\" x 6'-8\"",
            "glass_dimension": "27 5/16\" x 67\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "3'-1 1/2\" x 6'-7 1/2\"",
            "rough_opening": "3'-2 1/4\" x 6'-8\"",
            "glass_dimension": "26\" x 48\""
          }
        }
      },
      "3080": {
        "full_lite": {
          "all": {
            "unit_dimension": "3'-1 1/2\" x 7'-11 1/2\"",
            "rough_opening": "3'-2 1/4\" x 8'-0\"",
            "glass_dimension": "26\" x 80\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "3'-1 1/2\" x 7'-11 1/2\"",
            "rough_opening": "3'-2 1/4\" x 8'-0\"",
            "glass_dimension": "26\" x 64\""
          }
        }
      },
      "4068": {
        "full_lite": {
          "all": {
            "unit_dimension": "4'-1 1/2\" x 6'-7 1/2\"",
            "rough_opening": "4'-2 1/4\" x 6'-8\"",
            "glass_dimension": "38\" x 67\""
          }
        }
      },
      "4080": {
        "full_lite": {
          "all": {
            "unit_dimension": "4'-1 1/2\" x 7'-11 1/2\"",
            "rough_opening": "4'-2 1/4\" x 8'-0\"",
            "glass_dimension": "38\" x 80\""
          }
        }
      },
      "26611": {
        "full_lite": {
          "all": {
            "unit_dimension": "2'-7 1/2\" x 6'-10 3/8\"",
            "rough_opening": "2'-8 1/4\" x 6'-11\"",
            "glass_dimension": "21 5/16\" x 67\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "2'-7 1/2\" x 6'-10 3/8\"",
            "rough_opening": "2'-8 1/4\" x 6'-11\"",
            "glass_dimension": "20\" x 48\""
          }
        }
      },
      "30611": {
        "full_lite": {
          "all": {
            "unit_dimension": "3'-1 1/2\" x 6'-10 3/8\"",
            "rough_opening": "3'-2 1/4\" x 6'-11\"",
            "glass_dimension": "27 5/16\" x 67\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "3'-1 1/2\" x 6'-10 3/8\"",
            "rough_opening": "3'-2 1/4\" x 6'-11\"",
            "glass_dimension": "26\" x 48\""
          }
        }
      },
      "40611": {
        "full_lite": {
          "all": {
            "unit_dimension": "4'-1 1/2\" x 6'-10 3/8\"",
            "rough_opening": "4'-2 1/4\" x 6'-11\"",
            "glass_dimension": "38\" x 67\""
          }
        }
      }
    },
    "hinged_one_panel": {
      "1068": {
        "full_lite": {
          "all": {
            "unit_dimension": "1' x 6'-7 1/2\"",
            "rough_opening": "1'-3/4\" x 6'-8\"",
            "glass_dimension": "7\" x 64\""
          }
        }
      },
      "1080": {
        "full_lite": {
          "all": {
            "unit_dimension": "1' x 7'-11 1/2\"",
            "rough_opening": "1'-3/4\" x 8'-0\"",
            "glass_dimension": "7\" x 80\""
          }
        }
      },
      "1268": {
        "full_lite": {
          "all": {
            "unit_dimension": "1'-2\" x 6'-7 1/2\"",
            "rough_opening": "1'-2 3/4\" x 6'-8\"",
            "glass_dimension": "7\" x 64\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "1'-2\" x 6'-7 1/2\"",
            "rough_opening": "1'-2 3/4\" x 6'-8\"",
            "glass_dimension": "7\" x 48\""
          }
        }
      },
      "1280": {
        "full_lite": {
          "all": {
            "unit_dimension": "1'-2\" x 7'-11 1/2\"",
            "rough_opening": "1'-2 3/4\" x 8'-0\"",
            "glass_dimension": "7\" x 80\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "1'-2\" x 7'-11 1/2\"",
            "rough_opening": "1'-2 3/4\" x 8'-0\"",
            "glass_dimension": "8\" x 64\""
          }
        }
      },
      "2068": {
        "full_lite": {
          "all": {
            "unit_dimension": "1'-11 1/4\" x 6'-7 1/2\"",
            "rough_opening": "2' x 6'-8\"",
            "glass_dimension": "13 3/8\" x 64\""
          }
        }
      },
      "2080": {
        "full_lite": {
          "all": {
            "unit_dimension": "1'-11 1/4\" x 7'-11 1/2\"",
            "rough_opening": "2' x 8'-0\"",
            "glass_dimension": "13 3/8\" x 80\""
          }
        }
      },
      "2668": {
        "full_lite": {
          "all": {
            "unit_dimension": "2'-6 5/8\" x 6'-7 1/2\"",
            "rough_opening": "2'-7 3/8\" x 6'-8\"",
            "glass_dimension": "20\" x 64\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "2'-6 5/8\" x 6'-7 1/2\"",
            "rough_opening": "2'-7 3/8\" x 6'-8\"",
            "glass_dimension": "20\" x 48\""
          }
        }
      },
      "2680": {
        "full_lite": {
          "all": {
            "unit_dimension": "2'-6 5/8\" x 7'-11 1/2\"",
            "rough_opening": "2'-7 3/8\" x 8'-0\"",
            "glass_dimension": "20\" x 80\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "2'-6 5/8\" x 7'-11 1/2\"",
            "rough_opening": "2'-7 3/8\" x 8'-0\"",
            "glass_dimension": "20\" x 64\""
          }
        }
      },
      "2868": {
        "full_lite": {
          "all": {
            "unit_dimension": "2'-8 5/8\" x 6'-7 1/2\"",
            "rough_opening": "2'-9 3/8\" x 6'-8\"",
            "glass_dimension": "22\" x 64\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "2'-8 5/8\" x 6'-7 1/2\"",
            "rough_opening": "2'-9 3/8\" x 6'-8\"",
            "glass_dimension": "22\" x 48\""
          }
        }
      },
      "2880": {
        "full_lite": {
          "all": {
            "unit_dimension": "2'-8 5/8\" x 7'-11 1/2\"",
            "rough_opening": "2'-9 3/8\" x 8'-0\"",
            "glass_dimension": "20\" x 80\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "2'-8 5/8\" x 7'-11 1/2\"",
            "rough_opening": "2'-9 3/8\" x 8'-0\"",
            "glass_dimension": "22\" x 64\""
          }
        }
      },
      "3068": {
        "full_lite": {
          "all": {
            "unit_dimension": "3'-0 5/8\" x 6'-7 1/2\"",
            "rough_opening": "3'-1 3/8\" x 6'-8\"",
            "glass_dimension": "26\" x 64\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "3'-0 5/8\" x 6'-7 1/2\"",
            "rough_opening": "3'-1 3/8\" x 6'-8\"",
            "glass_dimension": "26\" x 48\""
          }
        }
      },
      "3076": {
        "full_lite": {
          "all": {
            "unit_dimension": "3'-0 5/8\" x 7'-5 1/2\"",
            "rough_opening": "3'-1 3/8\" x 7'-6\"",
            "glass_dimension": "24 1/2\" x 70\""
          }
        }
      },
      "3080": {
        "full_lite": {
          "all": {
            "unit_dimension": "3'-0 5/8\" x 7'-11 1/2\"",
            "rough_opening": "3'-1 3/8\" x 8'-0\"",
            "glass_dimension": "22\" x 80\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "3'-0 5/8\" x 7'-11 1/2\"",
            "rough_opening": "3'-1 3/8\" x 8'-0\"",
            "glass_dimension": "26\" x 64\""
          }
        }
      },
      "10611": {
        "full_lite": {
          "all": {
            "unit_dimension": "1' x 6'-10 1/2\"",
            "rough_opening": "1'-3/4\" x 6'-11\"",
            "glass_dimension": "7\" x 64\""
          }
        }
      },
      "12611": {
        "full_lite": {
          "all": {
            "unit_dimension": "1'-2\" x 6'-10 1/2\"",
            "rough_opening": "1'-2 3/4\" x 6'-11\"",
            "glass_dimension": "7\" x 64\""
          }
        },
        "three_quarter_lite": {
          "inswing": {
            "unit_dimension": "1'-2\" x 6'-10 1/2\"",
            "rough_opening": "1'-2 3/4\" x 6'-11\"",
            "glass_dimension": "7\" x 48\""
          },
          "outswing": {
            "unit_dimension": "1'-2\" x 6'-9 1/4\"",
            "rough_opening": "1'-2 3/4\" x 6'-11\"",
            "glass_dimension": "7\" x 48\""
          }
        }
      },
      "20611": {
        "full_lite": {
          "all": {
            "unit_dimension": "1'-11 1/4\" x 6'-10 1/2\"",
            "rough_opening": "2' x 6'-11\"",
            "glass_dimension": "13 3/8\" x 64\""
          }
        }
      },
      "26611": {
        "full_lite": {
          "all": {
            "unit_dimension": "2'-6 5/8\" x 6'-10 1/2\"",
            "rough_opening": "2'-7 3/8\" x 6'-11\"",
            "glass_dimension": "20\" x 64\""
          }
        },
        "three_quarter_lite": {
          "inswing": {
            "unit_dimension": "2'-6 5/8\" x 6'-10 1/2\"",
            "rough_opening": "2'-7 3/8\" x 6'-11\"",
            "glass_dimension": "20\" x 48\""
          },
          "outswing": {
            "unit_dimension": "2'-6 5/8\" x 6'-9 1/4\"",
            "rough_opening": "2'-7 3/8\" x 6'-11\"",
            "glass_dimension": "20\" x 48\""
          }
        }
      },
      "28611": {
        "full_lite": {
          "all": {
            "unit_dimension": "2'-8 5/8\" x 6'-10 1/2\"",
            "rough_opening": "2'-9 3/8\" x 6'-11\"",
            "glass_dimension": "22\" x 64\""
          }
        },
        "three_quarter_lite": {
          "inswing": {
            "unit_dimension": "2'-8 5/8\" x 6'-10 1/2\"",
            "rough_opening": "2'-9 3/8\" x 6'-11\"",
            "glass_dimension": "22\" x 48\""
          },
          "outswing": {
            "unit_dimension": "2'-8 5/8\" x 6'-9 1/4\"",
            "rough_opening": "2'-9 3/8\" x 6'-11\"",
            "glass_dimension": "22\" x 48\""
          }
        }
      },
      "30611": {
        "full_lite": {
          "all": {
            "unit_dimension": "3'-0 5/8\" x 6'-10 1/2\"",
            "rough_opening": "3'-1 3/8\" x 6'-11\"",
            "glass_dimension": "26\" x 64\""
          }
        },
        "three_quarter_lite": {
          "inswing": {
            "unit_dimension": "3'-0 5/8\" x 6'-10 1/2\"",
            "rough_opening": "3'-1 3/8\" x 6'-11\"",
            "glass_dimension": "26\" x 48\""
          },
          "outswing": {
            "unit_dimension": "3'-0 5/8\" x 6'-9 1/4\"",
            "rough_opening": "3'-1 3/8\" x 6'-11\"",
            "glass_dimension": "26\" x 48\""
          }
        }
      }
    },
    "hinged_three_panel": {
      "7668": {
        "full_lite": {
          "all": {
            "unit_dimension": "7'-3 13/16\" x 6'-7 1/2\"",
            "rough_opening": "7'-4 9/16\" x 6'-8\"",
            "glass_dimension": "20\" x 64\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "7'-3 13/16\" x 6'-7 1/2\"",
            "rough_opening": "7'-4 9/16\" x 6'-8\"",
            "glass_dimension": "20\" x 48\""
          }
        }
      },
      "7680": {
        "full_lite": {
          "all": {
            "unit_dimension": "7'-3 13/16\" x 7'-11 1/2\"",
            "rough_opening": "7'-4 9/16\" x 8'-0\"",
            "glass_dimension": "20\" x 80\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "7'-3 13/16\" x 7'-11 1/2\"",
            "rough_opening": "7'-4 9/16\" x 8'-0\"",
            "glass_dimension": "20\" x 64\""
          }
        }
      },
      "8068": {
        "full_lite": {
          "all": {
            "unit_dimension": "7'-9 13/16\" x 6'-7 1/2\"",
            "rough_opening": "7'-10 9/16\" x 6'-8\"",
            "glass_dimension": "22\" x 64\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "7'-9 13/16\" x 6'-7 1/2\"",
            "rough_opening": "7'-10 9/16\" x 6'-8\"",
            "glass_dimension": "22\" x 48\""
          }
        }
      },
      "8080": {
        "full_lite": {
          "all": {
            "unit_dimension": "7'-9 13/16\" x 7'-11 1/2\"",
            "rough_opening": "7'-10 9/16\" x 8'-0\"",
            "glass_dimension": "20\" x 80\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "7'-9 13/16\" x 7'-11 1/2\"",
            "rough_opening": "7'-10 9/16\" x 8'-0\"",
            "glass_dimension": "22\" x 64\""
          }
        }
      },
      "9068": {
        "full_lite": {
          "all": {
            "unit_dimension": "8'-9 13/16\" x 6'-7 1/2\"",
            "rough_opening": "8'-10 9/16\" x 6'-8\"",
            "glass_dimension": "26\" x 64\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "8'-9 13/16\" x 6'-7 1/2\"",
            "rough_opening": "8'-10 9/16\" x 6'-8\"",
            "glass_dimension": "26\" x 48\""
          }
        }
      },
      "9076": {
        "full_lite": {
          "all": {
            "unit_dimension": "8'-9 13/16\" x 7'-5 1/2\"",
            "rough_opening": "8'-10 9/16\" x 7'-6\"",
            "glass_dimension": "24 1/2\" x 70\""
          }
        }
      },
      "9080": {
        "full_lite": {
          "all": {
            "unit_dimension": "8'-9 13/16\" x 7'-11 1/2\"",
            "rough_opening": "8'-10 9/16\" x 8'-0\"",
            "glass_dimension": "22\" x 80\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "8'-9 13/16\" x 7'-11 1/2\"",
            "rough_opening": "8'-10 9/16\" x 8'-0\"",
            "glass_dimension": "26\" x 64\""
          }
        }
      },
      "76611": {
        "full_lite": {
          "all": {
            "unit_dimension": "7'-3 13/16\" x 6'-10 1/2\"",
            "rough_opening": "7'-4 9/16\" x 6'-11\"",
            "glass_dimension": "20\" x 64\""
          }
        },
        "three_quarter_lite": {
          "inswing": {
            "unit_dimension": "7'-3 13/16\" x 6'-10 1/2\"",
            "rough_opening": "7'-4 9/16\" x 6'-11\"",
            "glass_dimension": "20\" x 48\""
          },
          "outswing": {
            "unit_dimension": "7'-3 13/16\" x 6'-9 1/4\"",
            "rough_opening": "7'-4 9/16\" x 6'-11\"",
            "glass_dimension": "20\" x 48\""
          }
        }
      },
      "80611": {
        "full_lite": {
          "all": {
            "unit_dimension": "7'-9 13/16\" x 6'-10 1/2\"",
            "rough_opening": "7'-10 9/16\" x 6'-11\"",
            "glass_dimension": "22\" x 64\""
          }
        },
        "three_quarter_lite": {
          "inswing": {
            "unit_dimension": "7'-9 13/16\" x 6'-10 1/2\"",
            "rough_opening": "7'-10 9/16\" x 6'-11\"",
            "glass_dimension": "22\" x 48\""
          },
          "outswing": {
            "unit_dimension": "7'-9 13/16\" x 6'-9 1/4\"",
            "rough_opening": "7'-10 9/16\" x 6'-11\"",
            "glass_dimension": "22\" x 48\""
          }
        }
      },
      "90611": {
        "full_lite": {
          "all": {
            "unit_dimension": "8'-9 13/16\" x 6'-10 1/2\"",
            "rough_opening": "8'-10 9/16\" x 6'-11\"",
            "glass_dimension": "26\" x 64\""
          }
        },
        "three_quarter_lite": {
          "inswing": {
            "unit_dimension": "8'-9 13/16\" x 6'-10 1/2\"",
            "rough_opening": "8'-10 9/16\" x 6'-11\"",
            "glass_dimension": "26\" x 48\""
          },
          "outswing": {
            "unit_dimension": "8'-9 13/16\" x 6'-9 1/4\"",
            "rough_opening": "8'-10 9/16\" x 6'-11\"",
            "glass_dimension": "26\" x 48\""
          }
        }
      }
    },
    "hinged_two_panel": {
      "4068": {
        "full_lite": {
          "all": {
            "unit_dimension": "4'-2\" x 6'-7 1/2\"",
            "rough_opening": "4'-2 3/4\" x 6'-8\"",
            "glass_dimension": "13 3/8\" x 64\""
          }
        }
      },
      "4080": {
        "full_lite": {
          "all": {
            "unit_dimension": "4'-2\" x 7'-11 1/2\"",
            "rough_opening": "4'-2 3/4\" x 8'-0\"",
            "glass_dimension": "13 3/8\" x 80\""
          }
        }
      },
      "5068": {
        "full_lite": {
          "all": {
            "unit_dimension": "4'-11 1/4\" x 6'-7 1/2\"",
            "rough_opening": "5' x 6'-8\"",
            "glass_dimension": "20\" x 64\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "4'-11 1/4\" x 6'-7 1/2\"",
            "rough_opening": "5' x 6'-8\"",
            "glass_dimension": "20\" x 48\""
          }
        }
      },
      "5080": {
        "full_lite": {
          "all": {
            "unit_dimension": "4'-11 1/4\" x 7'-11 1/2\"",
            "rough_opening": "5' x 8'-0\"",
            "glass_dimension": "20\" x 80\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "4'-11 1/4\" x 7'-11 1/2\"",
            "rough_opening": "5' x 8'-0\"",
            "glass_dimension": "20\" x 64\""
          }
        }
      },
      "5468": {
        "full_lite": {
          "all": {
            "unit_dimension": "5'-3 1/4\" x 6'-7 1/2\"",
            "rough_opening": "5'-4\" x 6'-8\"",
            "glass_dimension": "22\" x 64\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "5'-3 1/4\" x 6'-7 1/2\"",
            "rough_opening": "5'-4\" x 6'-8\"",
            "glass_dimension": "22\" x 48\""
          }
        }
      },
      "5480": {
        "full_lite": {
          "all": {
            "unit_dimension": "5'-3 1/4\" x 7'-11 1/2\"",
            "rough_opening": "5'-4\" x 8'-0\"",
            "glass_dimension": "20\" x 80\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "5'-3 1/4\" x 7'-11 1/2\"",
            "rough_opening": "5'-4\" x 8'-0\"",
            "glass_dimension": "22\" x 64\""
          }
        }
      },
      "6068": {
        "full_lite": {
          "all": {
            "unit_dimension": "5'-11 1/4\" x 6'-7 1/2\"",
            "rough_opening": "6' x 6'-8\"",
            "glass_dimension": "26\" x 64\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "5'-11 1/4\" x 6'-7 1/2\"",
            "rough_opening": "6' x 6'-8\"",
            "glass_dimension": "26\" x 48\""
          }
        }
      },
      "6076": {
        "full_lite": {
          "all": {
            "unit_dimension": "5'-11 1/4\" x 7'-5 1/2\"",
            "rough_opening": "6' x 7'-6\"",
            "glass_dimension": "24 1/2\" x 70\""
          }
        }
      },
      "6080": {
        "full_lite": {
          "all": {
            "unit_dimension": "5'-11 1/4\" x 7'-11 1/2\"",
            "rough_opening": "6' x 8'-0\"",
            "glass_dimension": "22\" x 80\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "5'-11 1/4\" x 7'-11 1/2\"",
            "rough_opening": "6' x 8'-0\"",
            "glass_dimension": "26\" x 64\""
          }
        }
      },
      "40611": {
        "full_lite": {
          "all": {
            "unit_dimension": "4'-2\" x 6'-10 1/2\"",
            "rough_opening": "4'-2 3/4\" x 6'-11\"",
            "glass_dimension": "13 3/8\" x 64\""
          }
        }
      },
      "50611": {
        "full_lite": {
          "all": {
            "unit_dimension": "4'-11 1/4\" x 6'-10 1/2\"",
            "rough_opening": "5' x 6'-11\"",
            "glass_dimension": "20\" x 64\""
          }
        },
        "three_quarter_lite": {
          "inswing": {
            "unit_dimension": "4'-11 1/4\" x 6'-10 1/2\"",
            "rough_opening": "5' x 6'-11\"",
            "glass_dimension": "20\" x 48\""
          },
          "outswing": {
            "unit_dimension": "4'-11 1/4\" x 6'-9 1/4\"",
            "rough_opening": "5' x 6'-11\"",
            "glass_dimension": "20\" x 48\""
          }
        }
      },
      "54611": {
        "full_lite": {
          "all": {
            "unit_dimension": "5'-3 1/4\" x 6'-10 1/2\"",
            "rough_opening": "5'-4\" x 6'-11\"",
            "glass_dimension": "22\" x 64\""
          }
        },
        "three_quarter_lite": {
          "inswing": {
            "unit_dimension": "5'-3 1/4\" x 6'-10 1/2\"",
            "rough_opening": "5'-4\" x 6'-11\"",
            "glass_dimension": "22\" x 48\""
          },
          "outswing": {
            "unit_dimension": "5'-3 1/4\" x 6'-9 1/4\"",
            "rough_opening": "5'-4\" x 6'-11\"",
            "glass_dimension": "22\" x 48\""
          }
        }
      },
      "60611": {
        "full_lite": {
          "all": {
            "unit_dimension": "5'-11 1/4\" x 6'-10 1/2\"",
            "rough_opening": "6' x 6'-11\"",
            "glass_dimension": "26\" x 64\""
          }
        },
        "three_quarter_lite": {
          "inswing": {
            "unit_dimension": "5'-11 1/4\" x 6'-10 1/2\"",
            "rough_opening": "6' x 6'-11\"",
            "glass_dimension": "26\" x 48\""
          },
          "outswing": {
            "unit_dimension": "5'-11 1/4\" x 6'-9 1/4\"",
            "rough_opening": "6' x 6'-11\"",
            "glass_dimension": "26\" x 48\""
          }
        }
      }
    }
  },
  "gliding": {
    "gliding_2_panel": {
      "5068": {
        "full_lite": {
          "all": {
            "unit_dimension": "4'-11 1/4\" x 6'-7 1/2\"",
            "rough_opening": "5' x 6'-8\"",
            "glass_dimension": "21 5/16\" x 67\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "4'-11 1/4\" x 6'-7 1/2\"",
            "rough_opening": "5' x 6'-8\"",
            "glass_dimension": "20\" x 48\""
          }
        }
      },
      "6068": {
        "full_lite": {
          "all": {
            "unit_dimension": "5'-11 1/4\" x 6'-7 1/2\"",
            "rough_opening": "6' x 6'-8\"",
            "glass_dimension": "27 5/16\" x 67\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "5'-11 1/4\" x 6'-7 1/2\"",
            "rough_opening": "6' x 6'-8\"",
            "glass_dimension": "26\" x 48\""
          }
        }
      },
      "8068": {
        "full_lite": {
          "all": {
            "unit_dimension": "7'-11 1/4\" x 6'-7 1/2\"",
            "rough_opening": "8' x 6'-8\"",
            "glass_dimension": "38\" x 67\""
          }
        }
      },
      "50611": {
        "full_lite": {
          "all": {
            "unit_dimension": "4'-11 1/4\" x 6'-10 3/8\"",
            "rough_opening": "5' x 6'-11\"",
            "glass_dimension": "21 5/16\" x 67\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "4'-11 1/4\" x 6'-10 3/8\"",
            "rough_opening": "5' x 6'-11\"",
            "glass_dimension": "20\" x 48\""
          }
        }
      },
      "60611": {
        "full_lite": {
          "all": {
            "unit_dimension": "5'-11 1/4\" x 6'-10 3/8\"",
            "rough_opening": "6' x 6'-11\"",
            "glass_dimension": "27 5/16\" x 67\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "5'-11 1/4\" x 6'-10 3/8\"",
            "rough_opening": "6' x 6'-11\"",
            "glass_dimension": "26\" x 48\""
          }
        }
      },
      "80611": {
        "full_lite": {
          "all": {
            "unit_dimension": "7'-11 1/4\" x 6'-10 3/8\"",
            "rough_opening": "8' x 6'-11\"",
            "glass_dimension": "38\" x 67\""
          }
        }
      },
      "60710": {
        "full_lite": {
          "all": {
            "unit_dimension": "5'-11 1/4\" x 7'-9 1/4\"",
            "rough_opening": "6' x 7'-9 3/4\"",
            "glass_dimension": "26\" x 80\""
          }
        }
      },
      "5080": {
        "full_lite": {
          "all": {
            "unit_dimension": "4'-11 1/4\" x 7'-11 1/2\"",
            "rough_opening": "5' x 8'-0\"",
            "glass_dimension": "20\" x 80\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "4'-11 1/4\" x 7'-11 1/2\"",
            "rough_opening": "5' x 8'-0\"",
            "glass_dimension": "20\" x 64\""
          }
        }
      },
      "6080": {
        "full_lite": {
          "all": {
            "unit_dimension": "5'-11 1/4\" x 7'-11 1/2\"",
            "rough_opening": "6' x 8'-0\"",
            "glass_dimension": "26\" x 80\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "5'-11 1/4\" x 7'-11 1/2\"",
            "rough_opening": "6' x 8'-0\"",
            "glass_dimension": "26\" x 64\""
          }
        }
      },
      "8080": {
        "full_lite": {
          "all": {
            "unit_dimension": "7'-11 1/4\" x 7'-11 1/2\"",
            "rough_opening": "8' x 8'-0\"",
            "glass_dimension": "38\" x 80\""
          }
        }
      }
    },
    "gliding_3_panel": {
      "7668": {
        "full_lite": {
          "all": {
            "unit_dimension": "7'-7 3/8\" x 6'-7 1/2\"",
            "rough_opening": "7'-8 1/8\" x 6'-8\"",
            "glass_dimension": "21 5/16\" x 67\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "7'-7 3/8\" x 6'-7 1/2\"",
            "rough_opening": "7'-8 1/8\" x 6'-8\"",
            "glass_dimension": "20\" x 48\""
          }
        }
      },
      "9068": {
        "full_lite": {
          "all": {
            "unit_dimension": "9'-1 3/8\" x 6'-7 1/2\"",
            "rough_opening": "9'-2 1/8\" x 6'-8\"",
            "glass_dimension": "27 5/16\" x 67\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "9'-1 3/8\" x 6'-7 1/2\"",
            "rough_opening": "9'-2 1/8\" x 6'-8\"",
            "glass_dimension": "26\" x 48\""
          }
        }
      },
      "12068": {
        "full_lite": {
          "all": {
            "unit_dimension": "12'-1 3/8\" x 6'-7 1/2\"",
            "rough_opening": "12'-2 1/8\" x 6'-8\"",
            "glass_dimension": "38\" x 67\""
          }
        }
      },
      "76611": {
        "full_lite": {
          "all": {
            "unit_dimension": "7'-7 3/8\" x 6'-10 3/8\"",
            "rough_opening": "7'-8 1/8\" x 6'-11\"",
            "glass_dimension": "21 5/16\" x 67\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "7'-7 3/8\" x 6'-10 3/8\"",
            "rough_opening": "7'-8 1/8\" x 6'-11\"",
            "glass_dimension": "20\" x 48\""
          }
        }
      },
      "90611": {
        "full_lite": {
          "all": {
            "unit_dimension": "9'-1 3/8\" x 6'-10 3/8\"",
            "rough_opening": "9'-2 1/8\" x 6'-11\"",
            "glass_dimension": "27 5/16\" x 67\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "9'-1 3/8\" x 6'-10 3/8\"",
            "rough_opening": "9'-2 1/8\" x 6'-11\"",
            "glass_dimension": "26\" x 48\""
          }
        }
      },
      "120611": {
        "full_lite": {
          "all": {
            "unit_dimension": "12'-1 3/8\" x 6'-10 3/8\"",
            "rough_opening": "12'-2 1/8\" x 6'-11\"",
            "glass_dimension": "38\" x 67\""
          }
        }
      },
      "7680": {
        "full_lite": {
          "all": {
            "unit_dimension": "7'-7 3/8\" x 7'-11 1/2\"",
            "rough_opening": "7'-8 1/8\" x 8'-0\"",
            "glass_dimension": "20\" x 80\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "7'-7 3/8\" x 7'-11 1/2\"",
            "rough_opening": "7'-8 1/8\" x 8'-0\"",
            "glass_dimension": "20\" x 64\""
          }
        }
      },
      "9080": {
        "full_lite": {
          "all": {
            "unit_dimension": "9'-1 3/8\" x 7'-11 1/2\"",
            "rough_opening": "9'-2 1/8\" x 8'-0\"",
            "glass_dimension": "26\" x 80\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "9'-1 3/8\" x 7'-11 1/2\"",
            "rough_opening": "9'-2 1/8\" x 8'-0\"",
            "glass_dimension": "26\" x 64\""
          }
        }
      },
      "12080": {
        "full_lite": {
          "all": {
            "unit_dimension": "12'-1 3/8\" x 7'-11 1/2\"",
            "rough_opening": "12'-2 1/8\" x 8'-0\"",
            "glass_dimension": "38\" x 80\""
          }
        }
      }
    },
    "gliding_4_panel": {
      "10068": {
        "full_lite": {
          "all": {
            "unit_dimension": "9'-9 1/4\" x 6'-7 1/2\"",
            "rough_opening": "9'-10\" x 6'-8\"",
            "glass_dimension": "21 5/16\" x 67\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "9'-9 1/4\" x 6'-7 1/2\"",
            "rough_opening": "9'-10\" x 6'-8\"",
            "glass_dimension": "20\" x 48\""
          }
        }
      },
      "12068": {
        "full_lite": {
          "all": {
            "unit_dimension": "11'-9 1/8\" x 6'-7 1/2\"",
            "rough_opening": "11'-9 7/8\" x 6'-8\"",
            "glass_dimension": "27 5/16\" x 67\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "11'-9 1/8\" x 6'-7 1/2\"",
            "rough_opening": "11'-9 7/8\" x 6'-8\"",
            "glass_dimension": "26\" x 48\""
          }
        }
      },
      "100611": {
        "full_lite": {
          "all": {
            "unit_dimension": "9'-9 1/4\" x 6'-10 3/8\"",
            "rough_opening": "9'-10\" x 6'-11\"",
            "glass_dimension": "21 5/16\" x 67\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "9'-9 1/4\" x 6'-10 3/8\"",
            "rough_opening": "9'-10\" x 6'-11\"",
            "glass_dimension": "20\" x 48\""
          }
        }
      },
      "120611": {
        "full_lite": {
          "all": {
            "unit_dimension": "11'-9 1/8\" x 6'-10 3/8\"",
            "rough_opening": "11'-9 7/8\" x 6'-11\"",
            "glass_dimension": "27 5/16\" x 67\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "11'-9 1/8\" x 6'-10 3/8\"",
            "rough_opening": "11'-9 7/8\" x 6'-11\"",
            "glass_dimension": "26\" x 48\""
          }
        }
      },
      "10080": {
        "full_lite": {
          "all": {
            "unit_dimension": "9'-9 1/4\" x 7'-11 1/2\"",
            "rough_opening": "9'-10\" x 8'-0\"",
            "glass_dimension": "20\" x 80\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "9'-9 1/4\" x 7'-11 1/2\"",
            "rough_opening": "9'-10\" x 8'-0\"",
            "glass_dimension": "20\" x 64\""
          }
        }
      },
      "12080": {
        "full_lite": {
          "all": {
            "unit_dimension": "11'-9 1/8\" x 7'-11 1/2\"",
            "rough_opening": "11'-9 7/8\" x 8'-0\"",
            "glass_dimension": "26\" x 80\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "11'-9 1/8\" x 7'-11 1/2\"",
            "rough_opening": "11'-9 7/8\" x 8'-0\"",
            "glass_dimension": "26\" x 64\""
          }
        }
      }
    },
    "bypass_gliding": {
      "9068": {
        "full_lite": {
          "all": {
            "unit_dimension": "8'-9 3/4\" x 6'-7 5/16\"",
            "rough_opening": "8'-10 1/2\" x 6'-8\"",
            "glass_dimension": "27 5/16\" x 67\""
          }
        }
      },
      "90611": {
        "full_lite": {
          "all": {
            "unit_dimension": "8'-9 3/4\" x 6'-10 3/16\"",
            "rough_opening": "8'-10 1/2\" x 6'-11\"",
            "glass_dimension": "27 5/16\" x 67\""
          }
        }
      },
      "9080": {
        "full_lite": {
          "all": {
            "unit_dimension": "8'-9 3/4\" x 7'-11 1/4\"",
            "rough_opening": "8'-10 1/2\" x 8'-0\"",
            "glass_dimension": "26\" x 80\""
          }
        }
      }
    }
  },
  "hinged": {
    "center_hinged": {
      "5068": {
        "full_lite": {
          "all": {
            "unit_dimension": "4'-11 1/4\" x 6'-7 1/2\"",
            "rough_opening": "5' x 6'-8\"",
            "glass_dimension": "20\" x 64\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "4'-11 1/4\" x 6'-7 1/2\"",
            "rough_opening": "5' x 6'-8\"",
            "glass_dimension": "20\" x 48\""
          }
        }
      },
      "5080": {
        "full_lite": {
          "all": {
            "unit_dimension": "4'-11 1/4\" x 7'-11 1/2\"",
            "rough_opening": "5' x 8'-0\"",
            "glass_dimension": "20\" x 80\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "4'-11 1/4\" x 7'-11 1/2\"",
            "rough_opening": "5' x 8'-0\"",
            "glass_dimension": "20\" x 64\""
          }
        }
      },
      "5468": {
        "full_lite": {
          "all": {
            "unit_dimension": "5'-3 1/4\" x 6'-7 1/2\"",
            "rough_opening": "5'-4\" x 6'-8\"",
            "glass_dimension": "22\" x 64\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "5'-3 1/4\" x 6'-7 1/2\"",
            "rough_opening": "5'-4\" x 6'-8\"",
            "glass_dimension": "22\" x 48\""
          }
        }
      },
      "5480": {
        "full_lite": {
          "all": {
            "unit_dimension": "5'-3 1/4\" x 7'-11 1/2\"",
            "rough_opening": "5'-4\" x 8'-0\"",
            "glass_dimension": "20\" x 80\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "5'-3 1/4\" x 7'-11 1/2\"",
            "rough_opening": "5'-4\" x 8'-0\"",
            "glass_dimension": "22\" x 64\""
          }
        }
      },
      "6068": {
        "full_lite": {
          "all": {
            "unit_dimension": "5'-11 1/4\" x 6'-7 1/2\"",
            "rough_opening": "6' x 6'-8\"",
            "glass_dimension": "26\" x 64\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "5'-11 1/4\" x 6'-7 1/2\"",
            "rough_opening": "6' x 6'-8\"",
            "glass_dimension": "26\" x 48\""
          }
        }
      },
      "6076": {
        "full_lite": {
          "all": {
            "unit_dimension": "5'-11 1/4\" x 7'-5 1/2\"",
            "rough_opening": "6' x 7'-6\"",
            "glass_dimension": "24 1/2\" x 70\""
          }
        }
      },
      "6080": {
        "full_lite": {
          "all": {
            "unit_dimension": "5'-11 1/4\" x 7'-11 1/2\"",
            "rough_opening": "6' x 8'-0\"",
            "glass_dimension": "22\" x 80\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "5'-11 1/4\" x 7'-11 1/2\"",
            "rough_opening": "6' x 8'-0\"",
            "glass_dimension": "26\" x 64\""
          }
        }
      },
      "7668": {
        "full_lite": {
          "all": {
            "unit_dimension": "7'-3 13/16\" x 6'-7 1/2\"",
            "rough_opening": "7'-4 9/16\" x 6'-8\"",
            "glass_dimension": "20\" x 64\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "7'-3 13/16\" x 6'-7 1/2\"",
            "rough_opening": "7'-4 9/16\" x 6'-8\"",
            "glass_dimension": "20\" x 48\""
          }
        }
      },
      "7680": {
        "full_lite": {
          "all": {
            "unit_dimension": "7'-3 13/16\" x 7'-11 1/2\"",
            "rough_opening": "7'-4 9/16\" x 8'-0\"",
            "glass_dimension": "20\" x 80\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "7'-3 13/16\" x 7'-11 1/2\"",
            "rough_opening": "7'-4 9/16\" x 8'-0\"",
            "glass_dimension": "20\" x 64\""
          }
        }
      },
      "8068": {
        "full_lite": {
          "all": {
            "unit_dimension": "7'-9 13/16\" x 6'-7 1/2\"",
            "rough_opening": "7'-10 9/16\" x 6'-8\"",
            "glass_dimension": "22\" x 64\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "7'-9 13/16\" x 6'-7 1/2\"",
            "rough_opening": "7'-10 9/16\" x 6'-8\"",
            "glass_dimension": "22\" x 48\""
          }
        }
      },
      "8080": {
        "full_lite": {
          "all": {
            "unit_dimension": "7'-9 13/16\" x 7'-11 1/2\"",
            "rough_opening": "7'-10 9/16\" x 8'-0\"",
            "glass_dimension": "20\" x 80\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "7'-9 13/16\" x 7'-11 1/2\"",
            "rough_opening": "7'-10 9/16\" x 8'-0\"",
            "glass_dimension": "22\" x 64\""
          }
        }
      },
      "9068": {
        "full_lite": {
          "all": {
            "unit_dimension": "8'-9 13/16\" x 6'-7 1/2\"",
            "rough_opening": "8'-10 9/16\" x 6'-8\"",
            "glass_dimension": "26\" x 64\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "8'-9 13/16\" x 6'-7 1/2\"",
            "rough_opening": "8'-10 9/16\" x 6'-8\"",
            "glass_dimension": "26\" x 48\""
          }
        }
      },
      "9076": {
        "full_lite": {
          "all": {
            "unit_dimension": "8'-9 13/16\" x 7'-5 1/2\"",
            "rough_opening": "8'-10 9/16\" x 7'-6\"",
            "glass_dimension": "24 1/2\" x 70\""
          }
        }
      },
      "9080": {
        "full_lite": {
          "all": {
            "unit_dimension": "8'-9 13/16\" x 7'-11 1/2\"",
            "rough_opening": "8'-10 9/16\" x 8'-0\"",
            "glass_dimension": "22\" x 80\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "8'-9 13/16\" x 7'-11 1/2\"",
            "rough_opening": "8'-10 9/16\" x 8'-0\"",
            "glass_dimension": "26\" x 64\""
          }
        }
      },
      "50611": {
        "full_lite": {
          "all": {
            "unit_dimension": "4'-11 1/4\" x 6'-10 1/2\"",
            "rough_opening": "5' x 6'-11\"",
            "glass_dimension": "20\" x 64\""
          }
        },
        "three_quarter_lite": {
          "inswing": {
            "unit_dimension": "4'-11 1/4\" x 6'-10 1/2\"",
            "rough_opening": "5' x 6'-11\"",
            "glass_dimension": "20\" x 48\""
          },
          "outswing": {
            "unit_dimension": "4'-11 1/4\" x 6'-9 1/4\"",
            "rough_opening": "5' x 6'-11\"",
            "glass_dimension": "20\" x 48\""
          }
        }
      },
      "54611": {
        "full_lite": {
          "all": {
            "unit_dimension": "5'-3 1/4\" x 6'-10 1/2\"",
            "rough_opening": "5'-4\" x 6'-11\"",
            "glass_dimension": "22\" x 64\""
          }
        },
        "three_quarter_lite": {
          "inswing": {
            "unit_dimension": "5'-3 1/4\" x 6'-10 1/2\"",
            "rough_opening": "5'-4\" x 6'-11\"",
            "glass_dimension": "22\" x 48\""
          },
          "outswing": {
            "unit_dimension": "5'-3 1/4\" x 6'-9 1/4\"",
            "rough_opening": "5'-4\" x 6'-11\"",
            "glass_dimension": "22\" x 48\""
          }
        }
      },
      "60611": {
        "full_lite": {
          "all": {
            "unit_dimension": "5'-11 1/4\" x 6'-10 1/2\"",
            "rough_opening": "6' x 6'-11\"",
            "glass_dimension": "26\" x 64\""
          }
        },
        "three_quarter_lite": {
          "inswing": {
            "unit_dimension": "5'-11 1/4\" x 6'-10 1/2\"",
            "rough_opening": "6' x 6'-11\"",
            "glass_dimension": "26\" x 48\""
          },
          "outswing": {
            "unit_dimension": "5'-11 1/4\" x 6'-9 1/4\"",
            "rough_opening": "6' x 6'-11\"",
            "glass_dimension": "26\" x 48\""
          }
        }
      },
      "76611": {
        "full_lite": {
          "all": {
            "unit_dimension": "7'-3 13/16\" x 6'-10 1/2\"",
            "rough_opening": "7'-4 9/16\" x 6'-11\"",
            "glass_dimension": "20\" x 64\""
          }
        },
        "three_quarter_lite": {
          "inswing": {
            "unit_dimension": "7'-3 13/16\" x 6'-10 1/2\"",
            "rough_opening": "7'-4 9/16\" x 6'-11\"",
            "glass_dimension": "20\" x 48\""
          },
          "outswing": {
            "unit_dimension": "7'-3 13/16\" x 6'-9 1/4\"",
            "rough_opening": "7'-4 9/16\" x 6'-11\"",
            "glass_dimension": "20\" x 48\""
          }
        }
      },
      "80611": {
        "full_lite": {
          "all": {
            "unit_dimension": "7'-9 13/16\" x 6'-10 1/2\"",
            "rough_opening": "7'-10 9/16\" x 6'-11\"",
            "glass_dimension": "22\" x 64\""
          }
        },
        "three_quarter_lite": {
          "inswing": {
            "unit_dimension": "7'-9 13/16\" x 6'-10 1/2\"",
            "rough_opening": "7'-10 9/16\" x 6'-11\"",
            "glass_dimension": "22\" x 48\""
          },
          "outswing": {
            "unit_dimension": "7'-9 13/16\" x 6'-9 1/4\"",
            "rough_opening": "7'-10 9/16\" x 6'-11\"",
            "glass_dimension": "22\" x 48\""
          }
        }
      },
      "90611": {
        "full_lite": {
          "all": {
            "unit_dimension": "8'-9 13/16\" x 6'-10 1/2\"",
            "rough_opening": "8'-10 9/16\" x 6'-11\"",
            "glass_dimension": "26\" x 64\""
          }
        },
        "three_quarter_lite": {
          "inswing": {
            "unit_dimension": "8'-9 13/16\" x 6'-10 1/2\"",
            "rough_opening": "8'-10 9/16\" x 6'-11\"",
            "glass_dimension": "26\" x 48\""
          },
          "outswing": {
            "unit_dimension": "8'-9 13/16\" x 6'-9 1/4\"",
            "rough_opening": "8'-10 9/16\" x 6'-11\"",
            "glass_dimension": "26\" x 48\""
          }
        }
      }
    },
    "double_hinged": {
      "4068": {
        "full_lite": {
          "all": {
            "unit_dimension": "4'-2\" x 6'-7 1/2\"",
            "rough_opening": "4'-2 3/4\" x 6'-8\"",
            "glass_dimension": "13 3/8\" x 64\""
          }
        }
      },
      "4080": {
        "full_lite": {
          "all": {
            "unit_dimension": "4'-2\" x 7'-11 1/2\"",
            "rough_opening": "4'-2 3/4\" x 8'-0\"",
            "glass_dimension": "13 3/8\" x 80\""
          }
        }
      },
      "5068": {
        "full_lite": {
          "all": {
            "unit_dimension": "4'-11 1/4\" x 6'-7 1/2\"",
            "rough_opening": "5' x 6'-8\"",
            "glass_dimension": "20\" x 64\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "4'-11 1/4\" x 6'-7 1/2\"",
            "rough_opening": "5' x 6'-8\"",
            "glass_dimension": "20\" x 48\""
          }
        }
      },
      "5080": {
        "full_lite": {
          "all": {
            "unit_dimension": "4'-11 1/4\" x 7'-11 1/2\"",
            "rough_opening": "5' x 8'-0\"",
            "glass_dimension": "20\" x 80\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "4'-11 1/4\" x 7'-11 1/2\"",
            "rough_opening": "5' x 8'-0\"",
            "glass_dimension": "20\" x 64\""
          }
        }
      },
      "5468": {
        "full_lite": {
          "all": {
            "unit_dimension": "5'-3 1/4\" x 6'-7 1/2\"",
            "rough_opening": "5'-4\" x 6'-8\"",
            "glass_dimension": "22\" x 64\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "5'-3 1/4\" x 6'-7 1/2\"",
            "rough_opening": "5'-4\" x 6'-8\"",
            "glass_dimension": "22\" x 48\""
          }
        }
      },
      "5480": {
        "full_lite": {
          "all": {
            "unit_dimension": "5'-3 1/4\" x 7'-11 1/2\"",
            "rough_opening": "5'-4\" x 8'-0\"",
            "glass_dimension": "20\" x 80\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "5'-3 1/4\" x 7'-11 1/2\"",
            "rough_opening": "5'-4\" x 8'-0\"",
            "glass_dimension": "22\" x 64\""
          }
        }
      },
      "6068": {
        "full_lite": {
          "all": {
            "unit_dimension": "5'-11 1/4\" x 6'-7 1/2\"",
            "rough_opening": "6' x 6'-8\"",
            "glass_dimension": "26\" x 64\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "5'-11 1/4\" x 6'-7 1/2\"",
            "rough_opening": "6' x 6'-8\"",
            "glass_dimension": "26\" x 48\""
          }
        }
      },
      "6076": {
        "full_lite": {
          "all": {
            "unit_dimension": "5'-11 1/4\" x 7'-5 1/2\"",
            "rough_opening": "6' x 7'-6\"",
            "glass_dimension": "24 1/2\" x 70\""
          }
        }
      },
      "6080": {
        "full_lite": {
          "all": {
            "unit_dimension": "5'-11 1/4\" x 7'-11 1/2\"",
            "rough_opening": "6' x 8'-0\"",
            "glass_dimension": "22\" x 80\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "5'-11 1/4\" x 7'-11 1/2\"",
            "rough_opening": "6' x 8'-0\"",
            "glass_dimension": "26\" x 64\""
          }
        }
      },
      "40611": {
        "full_lite": {
          "all": {
            "unit_dimension": "4'-2\" x 6'-10 1/2\"",
            "rough_opening": "4'-2 3/4\" x 6'-11\"",
            "glass_dimension": "13 3/8\" x 64\""
          }
        }
      },
      "50611": {
        "full_lite": {
          "all": {
            "unit_dimension": "4'-11 1/4\" x 6'-10 1/2\"",
            "rough_opening": "5' x 6'-11\"",
            "glass_dimension": "20\" x 64\""
          }
        },
        "three_quarter_lite": {
          "inswing": {
            "unit_dimension": "4'-11 1/4\" x 6'-10 1/2\"",
            "rough_opening": "5' x 6'-11\"",
            "glass_dimension": "20\" x 48\""
          },
          "outswing": {
            "unit_dimension": "4'-11 1/4\" x 6'-9 1/4\"",
            "rough_opening": "5' x 6'-11\"",
            "glass_dimension": "20\" x 48\""
          }
        }
      },
      "54611": {
        "full_lite": {
          "all": {
            "unit_dimension": "5'-3 1/4\" x 6'-10 1/2\"",
            "rough_opening": "5'-4\" x 6'-11\"",
            "glass_dimension": "22\" x 64\""
          }
        },
        "three_quarter_lite": {
          "inswing": {
            "unit_dimension": "5'-3 1/4\" x 6'-10 1/2\"",
            "rough_opening": "5'-4\" x 6'-11\"",
            "glass_dimension": "22\" x 48\""
          },
          "outswing": {
            "unit_dimension": "5'-3 1/4\" x 6'-9 1/4\"",
            "rough_opening": "5'-4\" x 6'-11\"",
            "glass_dimension": "22\" x 48\""
          }
        }
      },
      "60611": {
        "full_lite": {
          "all": {
            "unit_dimension": "5'-11 1/4\" x 6'-10 1/2\"",
            "rough_opening": "6' x 6'-11\"",
            "glass_dimension": "26\" x 64\""
          }
        },
        "three_quarter_lite": {
          "inswing": {
            "unit_dimension": "5'-11 1/4\" x 6'-10 1/2\"",
            "rough_opening": "6' x 6'-11\"",
            "glass_dimension": "26\" x 48\""
          },
          "outswing": {
            "unit_dimension": "5'-11 1/4\" x 6'-9 1/4\"",
            "rough_opening": "6' x 6'-11\"",
            "glass_dimension": "26\" x 48\""
          }
        }
      }
    },
    "single_hinged": {
      "2268": {
        "full_lite": {
          "all": {
            "unit_dimension": "2'-2 1/16\" x 6'-7 1/2\"",
            "rough_opening": "2'-2 13/16\" x 6'-8\"",
            "glass_dimension": "13 3/8\" x 64\""
          }
        }
      },
      "2280": {
        "full_lite": {
          "all": {
            "unit_dimension": "2'-2 1/16\" x 7'-11 1/2\"",
            "rough_opening": "2'-2 13/16\" x 8'-0\"",
            "glass_dimension": "13 3/8\" x 80\""
          }
        }
      },
      "2668": {
        "full_lite": {
          "all": {
            "unit_dimension": "2'-6 5/8\" x 6'-7 1/2\"",
            "rough_opening": "2'-7 3/8\" x 6'-8\"",
            "glass_dimension": "20\" x 64\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "2'-6 5/8\" x 6'-7 1/2\"",
            "rough_opening": "2'-7 3/8\" x 6'-8\"",
            "glass_dimension": "20\" x 48\""
          }
        }
      },
      "2680": {
        "full_lite": {
          "all": {
            "unit_dimension": "2'-6 5/8\" x 7'-11 1/2\"",
            "rough_opening": "2'-7 3/8\" x 8'-0\"",
            "glass_dimension": "20\" x 80\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "2'-6 5/8\" x 7'-11 1/2\"",
            "rough_opening": "2'-7 3/8\" x 8'-0\"",
            "glass_dimension": "20\" x 64\""
          }
        }
      },
      "2868": {
        "full_lite": {
          "all": {
            "unit_dimension": "2'-8 5/8\" x 6'-7 1/2\"",
            "rough_opening": "2'-9 3/8\" x 6'-8\"",
            "glass_dimension": "22\" x 64\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "2'-8 5/8\" x 6'-7 1/2\"",
            "rough_opening": "2'-9 3/8\" x 6'-8\"",
            "glass_dimension": "22\" x 48\""
          }
        }
      },
      "2880": {
        "full_lite": {
          "all": {
            "unit_dimension": "2'-8 5/8\" x 7'-11 1/2\"",
            "rough_opening": "2'-9 3/8\" x 8'-0\"",
            "glass_dimension": "20\" x 80\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "2'-8 5/8\" x 7'-11 1/2\"",
            "rough_opening": "2'-9 3/8\" x 8'-0\"",
            "glass_dimension": "22\" x 64\""
          }
        }
      },
      "3068": {
        "full_lite": {
          "all": {
            "unit_dimension": "3'-0 5/8\" x 6'-7 1/2\"",
            "rough_opening": "3'-1 3/8\" x 6'-8\"",
            "glass_dimension": "26\" x 64\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "3'-0 5/8\" x 6'-7 1/2\"",
            "rough_opening": "3'-1 3/8\" x 6'-8\"",
            "glass_dimension": "26\" x 48\""
          }
        }
      },
      "3076": {
        "full_lite": {
          "all": {
            "unit_dimension": "3'-0 5/8\" x 7'-5 1/2\"",
            "rough_opening": "3'-1 3/8\" x 7'-6\"",
            "glass_dimension": "24 1/2\" x 70\""
          }
        }
      },
      "3080": {
        "full_lite": {
          "all": {
            "unit_dimension": "3'-0 5/8\" x 7'-11 1/2\"",
            "rough_opening": "3'-1 3/8\" x 8'-0\"",
            "glass_dimension": "22\" x 80\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "3'-0 5/8\" x 7'-11 1/2\"",
            "rough_opening": "3'-1 3/8\" x 8'-0\"",
            "glass_dimension": "26\" x 64\""
          }
        }
      },
      "4068": {
        "full_lite": {
          "all": {
            "unit_dimension": "4'-2\" x 6'-7 1/2\"",
            "rough_opening": "4'-2 3/4\" x 6'-8\"",
            "glass_dimension": "13 3/8\" x 64\""
          }
        }
      },
      "4080": {
        "full_lite": {
          "all": {
            "unit_dimension": "4'-2\" x 7'-11 1/2\"",
            "rough_opening": "4'-2 3/4\" x 8'-0\"",
            "glass_dimension": "13 3/8\" x 80\""
          }
        }
      },
      "5068": {
        "full_lite": {
          "all": {
            "unit_dimension": "4'-11 1/4\" x 6'-7 1/2\"",
            "rough_opening": "5' x 6'-8\"",
            "glass_dimension": "20\" x 64\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "4'-11 1/4\" x 6'-7 1/2\"",
            "rough_opening": "5' x 6'-8\"",
            "glass_dimension": "20\" x 48\""
          }
        }
      },
      "5080": {
        "full_lite": {
          "all": {
            "unit_dimension": "4'-11 1/4\" x 7'-11 1/2\"",
            "rough_opening": "5' x 8'-0\"",
            "glass_dimension": "20\" x 80\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "4'-11 1/4\" x 7'-11 1/2\"",
            "rough_opening": "5' x 8'-0\"",
            "glass_dimension": "20\" x 64\""
          }
        }
      },
      "5468": {
        "full_lite": {
          "all": {
            "unit_dimension": "5'-3 1/4\" x 6'-7 1/2\"",
            "rough_opening": "5'-4\" x 6'-8\"",
            "glass_dimension": "22\" x 64\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "5'-3 1/4\" x 6'-7 1/2\"",
            "rough_opening": "5'-4\" x 6'-8\"",
            "glass_dimension": "22\" x 48\""
          }
        }
      },
      "5480": {
        "full_lite": {
          "all": {
            "unit_dimension": "5'-3 1/4\" x 7'-11 1/2\"",
            "rough_opening": "5'-4\" x 8'-0\"",
            "glass_dimension": "20\" x 80\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "5'-3 1/4\" x 7'-11 1/2\"",
            "rough_opening": "5'-4\" x 8'-0\"",
            "glass_dimension": "22\" x 64\""
          }
        }
      },
      "6068": {
        "full_lite": {
          "all": {
            "unit_dimension": "5'-11 1/4\" x 6'-7 1/2\"",
            "rough_opening": "6' x 6'-8\"",
            "glass_dimension": "26\" x 64\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "5'-11 1/4\" x 6'-7 1/2\"",
            "rough_opening": "6' x 6'-8\"",
            "glass_dimension": "26\" x 48\""
          }
        }
      },
      "6076": {
        "full_lite": {
          "all": {
            "unit_dimension": "5'-11 1/4\" x 7'-5 1/2\"",
            "rough_opening": "6' x 7'-6\"",
            "glass_dimension": "24 1/2\" x 70\""
          }
        }
      },
      "6080": {
        "full_lite": {
          "all": {
            "unit_dimension": "5'-11 1/4\" x 7'-11 1/2\"",
            "rough_opening": "6' x 8'-0\"",
            "glass_dimension": "22\" x 80\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "5'-11 1/4\" x 7'-11 1/2\"",
            "rough_opening": "6' x 8'-0\"",
            "glass_dimension": "26\" x 64\""
          }
        }
      },
      "7668": {
        "full_lite": {
          "all": {
            "unit_dimension": "7'-3 13/16\" x 6'-7 1/2\"",
            "rough_opening": "7'-4 9/16\" x 6'-8\"",
            "glass_dimension": "20\" x 64\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "7'-3 13/16\" x 6'-7 1/2\"",
            "rough_opening": "7'-4 9/16\" x 6'-8\"",
            "glass_dimension": "20\" x 48\""
          }
        }
      },
      "7680": {
        "full_lite": {
          "all": {
            "unit_dimension": "7'-3 13/16\" x 7'-11 1/2\"",
            "rough_opening": "7'-4 9/16\" x 8'-0\"",
            "glass_dimension": "20\" x 80\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "7'-3 13/16\" x 7'-11 1/2\"",
            "rough_opening": "7'-4 9/16\" x 8'-0\"",
            "glass_dimension": "20\" x 64\""
          }
        }
      },
      "8068": {
        "full_lite": {
          "all": {
            "unit_dimension": "7'-9 13/16\" x 6'-7 1/2\"",
            "rough_opening": "7'-10 9/16\" x 6'-8\"",
            "glass_dimension": "22\" x 64\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "7'-9 13/16\" x 6'-7 1/2\"",
            "rough_opening": "7'-10 9/16\" x 6'-8\"",
            "glass_dimension": "22\" x 48\""
          }
        }
      },
      "8080": {
        "full_lite": {
          "all": {
            "unit_dimension": "7'-9 13/16\" x 7'-11 1/2\"",
            "rough_opening": "7'-10 9/16\" x 8'-0\"",
            "glass_dimension": "20\" x 80\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "7'-9 13/16\" x 7'-11 1/2\"",
            "rough_opening": "7'-10 9/16\" x 8'-0\"",
            "glass_dimension": "22\" x 64\""
          }
        }
      },
      "9068": {
        "full_lite": {
          "all": {
            "unit_dimension": "8'-9 13/16\" x 6'-7 1/2\"",
            "rough_opening": "8'-10 9/16\" x 6'-8\"",
            "glass_dimension": "26\" x 64\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "8'-9 13/16\" x 6'-7 1/2\"",
            "rough_opening": "8'-10 9/16\" x 6'-8\"",
            "glass_dimension": "26\" x 48\""
          }
        }
      },
      "9076": {
        "full_lite": {
          "all": {
            "unit_dimension": "8'-9 13/16\" x 7'-5 1/2\"",
            "rough_opening": "8'-10 9/16\" x 7'-6\"",
            "glass_dimension": "24 1/2\" x 70\""
          }
        }
      },
      "9080": {
        "full_lite": {
          "all": {
            "unit_dimension": "8'-9 13/16\" x 7'-11 1/2\"",
            "rough_opening": "8'-10 9/16\" x 8'-0\"",
            "glass_dimension": "22\" x 80\""
          }
        },
        "three_quarter_lite": {
          "all": {
            "unit_dimension": "8'-9 13/16\" x 7'-11 1/2\"",
            "rough_opening": "8'-10 9/16\" x 8'-0\"",
            "glass_dimension": "26\" x 64\""
          }
        }
      },
      "22611": {
        "full_lite": {
          "all": {
            "unit_dimension": "2'-2 1/16\" x 6'-10 1/2\"",
            "rough_opening": "2'-2 13/16\" x 6'-11\"",
            "glass_dimension": "13 3/8\" x 64\""
          }
        }
      },
      "26611": {
        "full_lite": {
          "all": {
            "unit_dimension": "2'-6 5/8\" x 6'-10 1/2\"",
            "rough_opening": "2'-7 3/8\" x 6'-11\"",
            "glass_dimension": "20\" x 64\""
          }
        },
        "three_quarter_lite": {
          "inswing": {
            "unit_dimension": "2'-6 5/8\" x 6'-10 1/2\"",
            "rough_opening": "2'-7 3/8\" x 6'-11\"",
            "glass_dimension": "20\" x 48\""
          },
          "outswing": {
            "unit_dimension": "2'-6 5/8\" x 6'-9 1/4\"",
            "rough_opening": "2'-7 3/8\" x 6'-11\"",
            "glass_dimension": "20\" x 48\""
          }
        }
      },
      "28611": {
        "full_lite": {
          "all": {
            "unit_dimension": "2'-8 5/8\" x 6'-10 1/2\"",
            "rough_opening": "2'-9 3/8\" x 6'-11\"",
            "glass_dimension": "22\" x 64\""
          }
        },
        "three_quarter_lite": {
          "inswing": {
            "unit_dimension": "2'-8 5/8\" x 6'-10 1/2\"",
            "rough_opening": "2'-9 3/8\" x 6'-11\"",
            "glass_dimension": "22\" x 48\""
          },
          "outswing": {
            "unit_dimension": "2'-8 5/8\" x 6'-9 1/4\"",
            "rough_opening": "2'-9 3/8\" x 6'-11\"",
            "glass_dimension": "22\" x 48\""
          }
        }
      },
      "30611": {
        "full_lite": {
          "all": {
            "unit_dimension": "3'-0 5/8\" x 6'-10 1/2\"",
            "rough_opening": "3'-1 3/8\" x 6'-11\"",
            "glass_dimension": "26\" x 64\""
          }
        },
        "three_quarter_lite": {
          "inswing": {
            "unit_dimension": "3'-0 5/8\" x 6'-10 1/2\"",
            "rough_opening": "3'-1 3/8\" x 6'-11\"",
            "glass_dimension": "26\" x 48\""
          },
          "outswing": {
            "unit_dimension": "3'-0 5/8\" x 6'-9 1/4\"",
            "rough_opening": "3'-1 3/8\" x 6'-11\"",
            "glass_dimension": "26\" x 48\""
          }
        }
      },
      "40611": {
        "full_lite": {
          "all": {
            "unit_dimension": "4'-2\" x 6'-10 1/2\"",
            "rough_opening": "4'-2 3/4\" x 6'-11\"",
            "glass_dimension": "13 3/8\" x 64\""
          }
        }
      },
      "50611": {
        "full_lite": {
          "all": {
            "unit_dimension": "4'-11 1/4\" x 6'-10 1/2\"",
            "rough_opening": "5' x 6'-11\"",
            "glass_dimension": "20\" x 64\""
          }
        }
      },
      "54611": {
        "full_lite": {
          "all": {
            "unit_dimension": "5'-3 1/4\" x 6'-10 1/2\"",
            "rough_opening": "5'-4\" x 6'-11\"",
            "glass_dimension": "22\" x 64\""
          }
        }
      },
      "60611": {
        "full_lite": {
          "all": {
            "unit_dimension": "5'-11 1/4\" x 6'-10 1/2\"",
            "rough_opening": "6' x 6'-11\"",
            "glass_dimension": "26\" x 64\""
          }
        }
      },
      "76611": {
        "full_lite": {
          "all": {
            "unit_dimension": "7'-3 13/16\" x 6'-10 1/2\"",
            "rough_opening": "7'-4 9/16\" x 6'-11\"",
            "glass_dimension": "20\" x 64\""
          }
        }
      },
      "80611": {
        "full_lite": {
          "all": {
            "unit_dimension": "7'-9 13/16\" x 6'-10 1/2\"",
            "rough_opening": "7'-10 9/16\" x 6'-11\"",
            "glass_dimension": "22\" x 64\""
          }
        }
      },
      "90611": {
        "full_lite": {
          "all": {
            "unit_dimension": "8'-9 13/16\" x 6'-10 1/2\"",
            "rough_opening": "8'-10 9/16\" x 6'-11\"",
            "glass_dimension": "26\" x 64\""
          }
        }
      }
    },
    "vented_sidelight": {
      "6068": {
        "full_lite": {
          "all": {
            "unit_dimension": "5'-10\" x 6'-7 1/2\"",
            "rough_opening": "5'-10 3/4\" x 6'-8\"",
            "glass_dimension": "9\" x 64\", 26\" x 64\" , 9\" x 64\""
          }
        }
      },
      "8068": {
        "full_lite": {
          "all": {
            "unit_dimension": "7'-10\" x 6'-7 1/2\"",
            "rough_opening": "7'-10 3/4\" x 6'-8\"",
            "glass_dimension": "9\" x 64\", 20\" x 64\" , 9\" x 64\""
          }
        }
      }
    }
  }
};
// ND compatibility aliases: Center Hinged 2/3-panel scripts use explicit style keys,
// while the dimension table is intentionally stored under the shared legacy key "center_hinged".
if (
  window.UNIT_DIMENSION_MAP &&
  window.UNIT_DIMENSION_MAP.hinged &&
  window.UNIT_DIMENSION_MAP.hinged.center_hinged
) {
  window.UNIT_DIMENSION_MAP.hinged.center_hinged_2_panel =
    window.UNIT_DIMENSION_MAP.hinged.center_hinged;

  window.UNIT_DIMENSION_MAP.hinged.center_hinged_3_panel =
    window.UNIT_DIMENSION_MAP.hinged.center_hinged;
}